import React from 'react';

import SwensensHR from './SwensensHR';

import Kid from './Kid';

import { parseMemberData } from './utils';

export default function KidsView({ token, memberData, updateMemberData }) {
    const { tierCode, currentCycleInfo } = parseMemberData(memberData)

    const kidList = Object.values(memberData?.['[Relationships]']?.children || {})
        .map(child => child.Item)
        .filter(childData => childData?.CardInfo?.MembershipTypeCode === 'Cool Rewards Junior')

    return (
        <>
            {(tierCode !== 'Cool Rewards Junior') && kidList.length > 0 && (
                <>
                    <p className="app-text">
                        <strong>Cool Rewards Junior Member{kidList.length > 1 && 's'}</strong>
                    </p>
                    {kidList.map((kid, idx) => (
                        <Kid key={`kid-${idx}`} kid={kid} parentToken={token} updateMemberData={updateMemberData} />
                    ))}
                    {tierCode !== 'Family Ambassador' && !!currentCycleInfo && (
                        // Add a HR if there is more content below
                        <SwensensHR />
                    )}
                </>
            )}
        </>
    );
}